module.exports = __webpack_public_path__ + "img/03mazda-cx30.e030ee54.png";